var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.candidateSummarySideMenuOpen && _vm.onlyIcon
      ? _c(
          "div",
          {
            staticClass: "toggle-profile-btn-icon btn-hover-gray",
            on: {
              click: function($event) {
                return _vm.toggleProfile()
              }
            }
          },
          [
            _c("i", { staticClass: "fa-solid fa-circle-user user-icon" }),
            _vm._v(" "),
            _c("i", { staticClass: "fa-solid fa-chevron-right" })
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.candidateSummarySideMenuOpen && !_vm.onlyIcon
      ? _c(
          "button",
          {
            staticClass:
              "btn btn-outline btn-lg toggle-profile-btn btn-hover-gray",
            on: {
              click: function($event) {
                return _vm.toggleProfile()
              }
            }
          },
          [
            _c("i", { staticClass: "fa-solid fa-circle-user" }),
            _vm._v(" Profile "),
            _c("i", { staticClass: "fa-solid fa-chevron-right" })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-369f8eb3", { render: render, staticRenderFns: staticRenderFns })
  }
}